module.exports = __webpack_public_path__ + "static/img/P.d2630e9e.png";